const E_EMPTY_CERT = 'You must select a package';

export const validate = ({ selectedCertificate }) => {
  var errors = {};

  if (!selectedCertificate) {
    errors.selected_certificate = E_EMPTY_CERT;
  }

  return [!Object.getOwnPropertyNames(errors).length, errors];
};

export default validate;
